<template>
    <div>
        <header class="replboxHead" style="position:fixed">
            <div class="btn_back" @click="$go(-1)">
                <a class="button"> </a>
            </div>
        </header>
        <div style="padding-top:48px;">
            <table id="Table_01" width="100%"  border="0" cellpadding="0" cellspacing="0" align="center">
                
                <tr>
                    <td colspan="2" style="background-color: #8f66f3;">
                        <img :src="$store.getters['systemStore/getImgPath']+promoDetail.dispBanner.img_path" alt="" usemap="#imagemap" id="promo_img"/>
                        <!-- <img src="@/assets/images/220823_1080_button.jpg" alt="" width="100%" @click="selectEvent"/>
                        <img src="@/assets/images/220823_1080_2.jpg" alt="" width="100%"/> -->
                    
                        <!-- <map name="imagemap">
                            <area shape="rect" coords="166,3783,907,3958" @click="getPosition">
                        </map> -->

                        <map name="imagemap" v-if="promoDetail.dispBanner.img_map_use_yn === 'Y'" v-html="promoDetail.dispBanner.img_map" @click="selectEvent">
                            
                        </map>
                    </td>


                </tr>

                <div class="popup disp_01">
                    <div class="popup_container">
                        <header class="popup_header">안 내</header>
                        <div class="popup_content">
                            <p v-html="alertMsg"></p>
                        </div>
                        <div class="popup_button">
                            <button class="btn_large" @click="$go(-1)">확 인</button>
                        </div>
                        
                    </div>
                    <div class="dimBg"></div>
                </div>
                
                <div class="popup main_04">
                    <div class="popup_container">
                        <header class="popup_header">안 내</header>
                        <div class="popup_content">
                            <p style="text-align:center">행사 URL이 복사되었습니다!<br/>지인에게 널리 공유해 주세요~</p>
                        </div>
                        <div class="popup_button">
                            <button class="btn_large">확인</button>
                        </div>
                        
                    </div>
                    <div class="dimBg"></div>
                </div>

            </table>
        </div>
        <Progress :active="progressActive"/>
    </div>

</template>
<script>
import {api} from '@/api/index.js'
import Progress from '@/components/Progress1'
import ImageMap from "image-map";

export default {
    data() {
        return {
            alertMsg: "",
            promoDetail: { dispBanner : {img_path : ''}},
            progressActive: false,
            imageMapHtml: ''
        }
    },
    mounted() {
        
        setTimeout(()=>{
            ImageMap('img[usemap]');
        }, 1000)
        

        $(document).ready(function(){
            
            
            $("#promo_img").width("100%");

            function copyClip(url){
                var $temp = $('<input>');
                $('body').append($temp);
                $temp.val(url).select();
                document.execCommand('copy');
                $temp.remove();
                // alert('URL이 복사되었습니다.');
                $('.main_04').addClass('active')
            }
            $('.copy-btn').on('click', function(e){
                e.preventDefault();
                var link = "https://bit.ly/3Ev7hzN";
                copyClip(link);
            });
            $('.btn_large').on('click', function(){
                $('.main_04').removeClass('active');
            });
        });
        
    },
    methods: {
        fnAlert(popup_class, msg) {
            this.alertMsg = msg;
            $('.'+popup_class).addClass('active');
        },
        getPosition(event) {
            var x = event.pageX;
            var y = event.pageY;
            var coords = "X coords: " + x + ", Y coords: " + y;
            console.log(coords);

        },
        selectEvent() {
            let obj = this.promoDetail.dispCtgDtl[0];
            
            if(obj === undefined) {
                this.fnAlert('disp_01','전시가 끝난 기획전입니다.');
                return;
            }
            
            this.progressActive = true;
            let params = {};

            params.event_nm = obj.disp_ctg_nm;
            params.event_divi_cd = obj.disp_ctg_no;

            params.searchTerm = obj.searchTerm;
            params.init_batch_dlv_yn = 'N';

            api.postAsync('/event/addEvent.do', params)
                .then(data=>{
                    
                    let url = `/eventDtl/${data.event_no}/recoSetting?init_batch_dlv_yn=${params.init_batch_dlv_yn}`;

                    this.$router.push(url);
                });
        },
    },
    async created(){
        await api.postAsync('/event/selectDispDetail.do', {banner_kind_cd:'10', banner_type_cd:'20', disp_ctg_no:this.$route.query.disp_ctg_no, shop_disp_type_cd_list : ["10", "90"]})
                .then (data => {
                    console.log(data.promoDetail)
                    this.promoDetail = data.promoDetail;
                    
                    if(this.promoDetail.dispCtgDtl.length === 0) {
                        this.fnAlert('disp_01','전시가 끝난 기획전입니다.');
                    }

                })
        
    },
    components: {Progress}
}

</script>


<style scoped>
.test {
    position: absolute;
    top: 150%;
  left: 48px;
}
</style>